import { NodeDefinitions } from "../pages/editor/editorSlice";
import { INodeVerification } from "../pages/treatments/import/NodeNotExisting";
import deletedBoxes from "../config/deletedbox.json";

//check if graph contain node unknow by catalog // accept if it's an Athea deleted Node

const nodeExistOrHasExisted = (catalog: NodeDefinitions, graph: string): INodeVerification[] => {
  const unKnowNodeTMP: INodeVerification[] = [];

  try {
    const parsedGraph = JSON.parse(graph);

    for (const key in parsedGraph.layers[1].models) {
      const node = parsedGraph.layers[1].models[key];

      if (node?.technicalName && node?.technicalType && node?.kind) {

        if (node.technicalType.toLowerCase() === "sticky-note") {
          continue;
        }

        const nodeInfo = {
          name: node.technicalName,
          type: node.technicalType,
        };

        const deletedMatch = deletedBoxes.find(
          (d) =>
            d.technicalName === node.technicalName &&
            d.kind.toLowerCase() === node.kind.toLowerCase()
        );
        if (deletedMatch) {
          continue;
        }

        const catalogList =
          // @ts-ignore
          catalog[node.kind + "s"] || [];

        const existsInCatalog = catalogList.some(
          (obj: any) =>
            obj.name === node.technicalName && obj.type === node.technicalType
        );

        if (!existsInCatalog) {
          unKnowNodeTMP.push(nodeInfo);
        }
      }
    }
  } catch {
    console.info("cannot parse data object");
  }

  return unKnowNodeTMP;
};

export default nodeExistOrHasExisted